import React, {useEffect} from 'react'
//  qimport {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
//import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'

import {MenuComponent} from '../assets/ts/components'

type Props = {
  children?: React.ReactNode
};
const MasterLayoutLobby: React.FC<Props> = ({children}) => {
  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        {/* {<AsideDefault /> } */}
        <div className='d-flex flex-column flex-row-fluid' id='kt_wrapper'> {/*className=wrapper*/}

          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            <div className='post d-flex flex-column-fluid align-center' id='kt_post'>
              <Content>{children}</Content>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayoutLobby}
